import { combineReducers } from "redux";

// Front — layout / breadcrumb (тема Lexa, скопировано verbatim)
import layoutReducer from "./redux/api/layout/layoutSlice";
import breadcrumbReducer from "./redux/api/breadcrumb/breadcrumbSlice";

// Authentication (RTK Query + slice)
import { authApi, authReducer } from "./redux/api/auth";

// Реестр feature-api-слайсов (пополняется страницами — см. featureApis.js)
import featureApis from "./featureApis";

const baseReducers = {
  layout: layoutReducer,
  breadcrumb: breadcrumbReducer,
  auth: authReducer,
  [authApi.reducerPath]: authApi.reducer,
};

// Динамически подключаем reducer каждого зарегистрированного feature-api.
const featureApiReducers = featureApis.reduce((acc, api) => {
  acc[api.reducerPath] = api.reducer;
  return acc;
}, {});

const rootReducer = combineReducers({
  ...baseReducers,
  ...featureApiReducers,
});

export default rootReducer;
